/* PUSHAS 2026 — product card "prices by size" on hover (desktop only).
   Hovering a product card shows every in-stock size with its lowest price over the image,
   so a shopper can scan prices without opening the product. Works on every card that uses
   .product-item + .card-media (home rows, collections, search, related products).
   Data: /products/<handle>.js, fetched once per product after a short hover-intent delay, then cached.
   Compact GOAT-style column on the right of the image: size and lowest price, with ⚡ only when that lowest
   price is the Fastest option (hover a row for its Fastest price). Condition variants are excluded. Each size links to its cheapest variant. */
(function () {
  if (!window.matchMedia || !matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var cache = {};
  var INTENT_MS = 140;
  var MAX_SIZES = 30;
  // Condition variants (Damaged Box, No Box, used) are left out: the panel shows standard-condition prices only. The PDP still lists them.
  var CONDITION = /damag|no box|missing box|used|worn|pre.?owned/i;
  var BOLT = '<svg viewBox="0 0 10 14" aria-hidden="true"><path d="M6.2 0 0 8h3.6L2.8 14 10 5.6H6.1z"/></svg>';

  var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AUD';
  var fmt;
  try { fmt = new Intl.NumberFormat('en-AU', { style: 'currency', currency: cur, maximumFractionDigits: 0 }); }
  catch (e) { fmt = { format: function (n) { return '$' + Math.round(n); } }; }
  function money(cents) { return fmt.format(cents / 100); }

  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function handleOf(item) {
    try { var j = JSON.parse(item.getAttribute('data-json-product') || '{}'); if (j.handle) return j.handle; } catch (e) {}
    var a = item.querySelector('a[href*="/products/"]');
    if (!a) return null;
    return a.getAttribute('href').split('/products/')[1].split(/[?#/]/)[0];
  }

  function load(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw r; return r.json(); })
        .catch(function () { delete cache[handle]; return null; });
    }
    return cache[handle];
  }

  // Collapse variants into sizes: lowest price per size, Fastest flag, cheapest variant id.
  function sizesOf(p) {
    var order = [], by = {};
    p.variants.forEach(function (v) {
      if (!v.available || CONDITION.test(v.title)) return;
      var fast = /\(fastest\)/i.test(v.title);
      var base = v.title.replace(/\s*\(fastest\)\s*/i, '').trim();
      var s = by[base];
      if (!s) { s = by[base] = { base: base, price: v.price, id: v.id, fast: false, compare: 0 }; order.push(s); }
      if (fast) { s.fast = true; s.fastPrice = Math.min(s.fastPrice || Infinity, v.price); }
      // Lowest price wins; on a tie the Fastest variant wins, so the row links to the faster option.
      if (v.price < s.price || (v.price === s.price && fast)) { s.price = v.price; s.id = v.id; }
      if (v.compare_at_price > v.price) s.compare = Math.max(s.compare, v.compare_at_price);
    });
    // Short labels for US men's sneaker sizing: "US M 9 / W 10.5" -> "9"
    var us = order.length && order.every(function (s) { return /^US M [\d.]+/.test(s.base); });
    // Row order: [⚡ if Fastest] [size] [price]; the always-present size and price stay aligned.
    order.forEach(function (s) { s.label = us ? s.base.match(/^US M ([\d.]+)/)[1] : esc(s.base); });
    return { sizes: order, unit: us ? 'US M' : '' };
  }

  function render(item, p) {
    var data = sizesOf(p);
    if (!data.sizes.length) return null;
    var min = Math.min.apply(null, data.sizes.map(function (s) { return s.price; }));
    // ⚡ only when the row's lowest price IS the Fastest option, so every ⚡ price ships Fastest.
    data.sizes.forEach(function (s) { s.bolt = s.fast && s.fastPrice === s.price; });
    var anyFast = data.sizes.some(function (s) { return s.bolt; });
    var shown = data.sizes.slice(0, MAX_SIZES);
    var url = '/products/' + p.handle;

    var el = document.createElement('div');
    el.className = 'p26-hv' + (data.unit ? '' : ' p26-hv--text');
    var h = '<div class="p26-hv-in">' + (data.unit ? '<div class="p26-hv-head">' + data.unit + '</div>' : '') +
      // Column widths are sized from the longest size label and price, so every row lines up.
      '<div class="p26-hv-list" style="--sw:' + Math.max.apply(null, shown.map(function (s) { return String(s.label).length; })) +
      'ch;--pw:' + Math.max.apply(null, shown.map(function (s) { return money(s.price).length; })) + 'ch">';
    shown.forEach(function (s, i) {
      var tip = s.base + ' · from ' + money(s.price) + (s.fast ? ' · Fastest ' + money(s.fastPrice) : '');
      h += '<a class="p26-hv-r' + (s.price === min ? ' is-low' : '') + '" style="--i:' + i + '" href="' + url + '?variant=' + s.id + '"' +
        ' title="' + esc(tip) + '">' + (s.bolt ? BOLT : '<i></i>') + '<b>' + s.label + '</b><span>' + money(s.price) + '</span></a>';
    });
    h += '</div>';
    if (data.sizes.length > shown.length) h += '<a class="p26-hv-more" href="' + url + '">+' + (data.sizes.length - shown.length) + '</a>';
    if (anyFast) h += '<div class="p26-hv-key">' + BOLT + 'Fastest</div>';
    el.innerHTML = h + '</div>';
    return el;
  }

  function show(item) {
    var media = item.querySelector('.card-media');
    if (!media || item.__p26hv === 'busy') return;
    if (item.__p26hvEl) { media.classList.add('p26-hv-on'); return; }
    var handle = handleOf(item);
    if (!handle) return;
    item.__p26hv = 'busy';
    load(handle).then(function (p) {
      item.__p26hv = null;
      if (!p || item.__p26hvEl) return;
      var el = render(item, p);
      if (!el) { item.__p26hvEl = 'none'; return; }
      item.__p26hvEl = el;
      media.appendChild(el);
      // Fade the list edges only when it actually scrolls.
      var list = el.querySelector('.p26-hv-list');
      if (list.scrollHeight > list.clientHeight + 1) {
        list.classList.add('is-scroll');
        list.addEventListener('scroll', function () {
          list.classList.toggle('at-top', list.scrollTop < 2);
          list.classList.toggle('at-end', list.scrollTop + list.clientHeight > list.scrollHeight - 2);
        }, { passive: true });
        list.classList.add('at-top');
      }
      if (item.matches(':hover') || item.contains(document.activeElement)) {
        requestAnimationFrame(function () { media.classList.add('p26-hv-on'); });
      }
    });
  }

  function hide(item) {
    var media = item.querySelector('.card-media');
    if (media) media.classList.remove('p26-hv-on');
  }

  document.addEventListener('mouseover', function (e) {
    var item = e.target.closest && e.target.closest('.product-item');
    if (!item || item.__p26t || (e.relatedTarget && item.contains(e.relatedTarget))) return;
    item.__p26t = setTimeout(function () { item.__p26t = null; show(item); }, INTENT_MS);
  });
  document.addEventListener('mouseout', function (e) {
    var item = e.target.closest && e.target.closest('.product-item');
    if (!item || (e.relatedTarget && item.contains(e.relatedTarget))) return;
    clearTimeout(item.__p26t); item.__p26t = null;
    hide(item);
  });
  document.addEventListener('focusin', function (e) {
    var item = e.target.closest && e.target.closest('.product-item');
    if (item) show(item);
  });
  document.addEventListener('focusout', function (e) {
    var item = e.target.closest && e.target.closest('.product-item');
    if (item && !item.contains(e.relatedTarget)) hide(item);
  });
})();

/* PDP tabs (Oct 2026): restyles the product page Description / Shipping / Returns / FAQs content (see pushas-2026-hover.css).
   Product descriptions are plain <p> blocks, so this adds structure without changing the copy:
   first paragraph -> lead; bold-only paragraphs ("Overview", "Key Highlights") -> eyebrow labels;
   "• Label: text" lines -> highlight cards; the "authenticated by hand" line -> callout; FAQ "Q:" lines -> questions. */
(function () {
  var SHIELD = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l7 3v5c0 4.5-3 8.5-7 10-4-1.5-7-5.5-7-10V6l7-3z"/><path d="M9 12l2 2 4-4"/></svg>';
  // Idempotent per content box: the theme re-renders the description after load (seen on phones), so a
  // MutationObserver re-applies it whenever a box's content is replaced.
  function enhance(box) {
    if (box.querySelector('.p26-lead, .p26-eyebrow, .p26-hl, .p26-q, .p26-trust')) return;
    var ps = Array.prototype.slice.call(box.querySelectorAll(':scope > p'));
    if (!ps.length) return;
    var first = ps[0];
    if (box.closest('#tab-description') && !(first.children.length === 1 && first.textContent.trim() === first.children[0].textContent.trim())) first.classList.add('p26-lead');
    var group = [];
    function flush() {
      if (group.length < 2) { group = []; return; }
      var grid = document.createElement('div'); grid.className = 'p26-hl';
      group.forEach(function (p) {
        var s = p.querySelector('strong'); var label = s ? s.textContent.replace(/:\s*$/, '') : '';
        var rest = p.textContent.replace(/^\s*•\s*/, '').replace(s ? s.textContent : '', '').replace(/^\s*:?\s*/, '');
        var card = document.createElement('div'); card.className = 'p26-hl-i';
        card.innerHTML = (label ? '<b></b>' : '') + '<span></span>';
        if (label) card.querySelector('b').textContent = label;
        card.querySelector('span').textContent = rest;
        grid.appendChild(card);
      });
      group[0].parentNode.insertBefore(grid, group[0]);
      group.forEach(function (p) { p.remove(); });
      group = [];
    }
    ps.forEach(function (p) {
      var t = p.textContent.trim();
      if (/^•/.test(t)) { if (group.length && group[group.length - 1].nextElementSibling !== p) flush(); group.push(p); return; }
      flush();
      var onlyStrong = p.children.length === 1 && p.children[0].tagName === 'STRONG' && t === p.children[0].textContent.trim();
      if (onlyStrong && /^Q:/i.test(t)) { p.classList.add('p26-q'); p.children[0].textContent = t.replace(/^Q:\s*/i, ''); }
      else if (onlyStrong && t.length < 40) p.classList.add('p26-eyebrow');
      else if (/authenticated by hand/i.test(t) && t.length < 160) { p.classList.add('p26-trust'); p.insertAdjacentHTML('afterbegin', SHIELD); }
    });
    flush();
  }
  // Phones: a long description is cut to a preview with a fade and a Read more button, so shoppers reach
  // Shipping, Returns and related products without scrolling through the whole write-up.
  function clamp(tab) {
    var box = tab.querySelector('#tab-description .toggle-content');
    if (!box || box.nextElementSibling && box.nextElementSibling.classList.contains('p26-more')) return;
    if (!window.matchMedia('(max-width: 550px)').matches || box.scrollHeight < 640) return;
    box.classList.add('p26-clamp');
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'p26-more'; btn.textContent = 'Read more';
    btn.addEventListener('click', function () {
      var open = box.classList.toggle('p26-clamp');
      btn.textContent = open ? 'Read more' : 'Show less';
      if (open) box.closest('.tab-content').scrollIntoView({ block: 'start', behavior: 'smooth' });
    });
    box.insertAdjacentElement('afterend', btn);
  }
  function run() {
    document.querySelectorAll('.halo-product-tab, .productView-tab').forEach(function (tab) {
      tab.classList.add('p26-tabs');
      tab.querySelectorAll('.toggle-content').forEach(enhance);
      clamp(tab);
      if (tab.__p26obs) return;
      var t;
      tab.__p26obs = new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { tab.querySelectorAll('.toggle-content').forEach(enhance); clamp(tab); }, 50); });
      tab.__p26obs.observe(tab, { childList: true, subtree: true });
    });
  }
  // Desktop: line the details grid up with the main image and buy box above it (their widths vary by screen size).
  function align() {
    var img = document.querySelector('.productView-nav') || document.querySelector('.productView-images'), det = document.querySelector('.productView-details');
    document.querySelectorAll('.productView-tab.p26-tabs').forEach(function (tab) {
      var props = ['--p26-ml', '--p26-w', '--p26-mw', '--p26-c1', '--p26-c2', '--p26-g'];
      if (window.innerWidth < 1200 || !img || !det) { props.forEach(function (k) { tab.style.removeProperty(k); }); return; }
      var a = img.getBoundingClientRect(), d = det.getBoundingClientRect(), par = tab.parentElement.getBoundingClientRect();
      var padL = parseFloat(getComputedStyle(tab.parentElement).paddingLeft) || 0;
      if (a.width < 200 || d.left <= a.right) return;
      tab.style.setProperty('--p26-ml', Math.round(a.left - par.left - padL) + 'px');
      tab.style.setProperty('--p26-w', Math.round(d.right - a.left) + 'px');
      tab.style.setProperty('--p26-mw', 'none');
      tab.style.setProperty('--p26-c1', Math.round(a.width) + 'px');
      tab.style.setProperty('--p26-c2', Math.round(d.width) + 'px');
      tab.style.setProperty('--p26-g', Math.round(d.left - a.right) + 'px');
    });
  }
  var rt;
  function boot() { run(); align(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('load', align);
  window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(align, 120); });
})();
